module.exports = __webpack_public_path__ + "media/images/athletes/1705-d9f1c1a859126db052470cca6bc1b3d9.png";